import React from 'react';
import { Link } from 'react-router-dom';
import { getChatUrl } from './get.chat.url';
import translate from './translate';

export const hasInvalidField = (errors, fieldName) => {
    return errors?.some(error => error.name === 'InvalidField' && error.field === fieldName);
};

export const get400InvalidUsernameOrPasswordError = (errors) => {
   const isAlreadyUsed = errors?.some(error => error.name === 'AlreadyUsed');
   const invalidUsername = hasInvalidField(errors, 'username') || hasInvalidField(errors, 'updates.username');
   const invalidPassword = hasInvalidField(errors, 'password') || hasInvalidField(errors, 'updates.password');

   if (isAlreadyUsed) {
      return 'Can\'t use previously used passwords, please enter a new password.';
   }
   if (invalidUsername) {
      return 'Please enter a username that meets the username guidelines.';
   }
   if (invalidPassword) {
      return 'The Password does not meet the required guidelines. Please enter the correct information and try again.';
   }

   return '';
};

export const getResetPasswordError = (errorCode, errors) => {
   const couldntProcessRequest = `${translate('Error')}: ${translate("We can't process your request at this time. We're sorry for any inconvenience. Please try again.")}`;
   const cannotBeFound = `${translate('Error')}: ${translate("We can't find you in our records. Check the information you entered and try again.")}`;
   const mustLogIn = <>
      {translate('Error')}: {translate('You must')}
      {' '}<Link to="/login">{translate('Log in').toLowerCase()}</Link>
      {' '}{translate('with your temporary password.')}
   </>;
   const analyticsMustLogInErrorMessage = `${translate('Error')}: ${translate('You must')} ${translate('Log in').toLowerCase()} ${translate('with your temporary password.')}`;
   const callToGetTempPassword = `${translate('Error')}: ${translate("You haven't set up your secret question and answer. Please call 1-800-MEDICARE (1-800-633-4227) to get a temporary password to log into your account. TTY users can call 1-877-486-2048.")}`;
   
   let errorMessage = couldntProcessRequest;
   let errorMessageInAnalytics = null;
   switch (errorCode) {
      case 400:
         const isLocked = errors.some(e => e.name === 'BadRequest' && e.message.includes('locked'));
         // user is disabled
         const isDisabled = errors.some(e => e.name === 'BadRequest' && e.message.includes('disabled'));
         
         const isMissingQuestions = errors.some(e => e.message === 'missing questions');
         const isTempPassword = errors.some(e => e.message === 'temporary password');
         // const isTempUsername = errors.some(e => e.message === 'temporary username');
         
         const invalidPasswordErrorMessage = get400InvalidUsernameOrPasswordError(errors);
         
         if (isDisabled) {
            errorMessage = <>
               {translate('Error')}: {translate('Your account is no longer active. To re-open your account,')}
               <a href={getChatUrl()}>{translate('chat with us')}</a> {translate('or call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048.')};
            </>;
            errorMessageInAnalytics = `${translate('Error')}: ${translate('Your account is no longer active. To re-open your account,')}
               ${translate('chat with us')} ${translate('or call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048.')};`
         } else if (isLocked) {
            errorMessage = <>
               {translate('Error')}: {translate('Your account was locked to protect your information.')}
               {' '}<Link to="/unlock-account">{translate('Unlock My Account')}.</Link>
            </>;
            errorMessageInAnalytics = `${translate('Error')}: ${translate('Your account was locked to protect your information.')} ${translate('Unlock My Account')}.`
         } else if (isMissingQuestions) {
            if (isTempPassword) {
               errorMessage = mustLogIn;
               errorMessageInAnalytics = analyticsMustLogInErrorMessage;
            } else {
               errorMessage = callToGetTempPassword;
            }
         } else if (invalidPasswordErrorMessage) {
            errorMessage = invalidPasswordErrorMessage;
         } else {
            errorMessage = cannotBeFound;
         }
         break;
      case 403:
         if (errors.some(e => e.message.includes('temporary password'))) {
            errorMessage = mustLogIn;
            errorMessageInAnalytics = analyticsMustLogInErrorMessage;
         } else {
            errorMessage = couldntProcessRequest;
         }
         break;
      case 404:
         errorMessage = cannotBeFound;
         break;
      default:
         errorMessage = couldntProcessRequest;
   }
   
   return { 
            applicationErrorMessage: errorMessage || couldntProcessRequest,
            analyticsErrorMessage: errorMessageInAnalytics ? errorMessageInAnalytics : errorMessage
         };
};

export const getUnlockAccountError = (errorCode, errors) => {
   let errorMessage = '';
   const invalidMBI = errors?.some(error => error.name === 'InvalidField' && error.field === 'mbi');
   const notLocked = errors?.some(error => error.message.includes('user is not locked'));
   
   if (notLocked) {
      return 'Your account is already unlocked.';
   } else if (invalidMBI) {
      return 'Please check your Medicare Number.';
   }
   
   if (errorCode === 400) {
      errorMessage = get400InvalidUsernameOrPasswordError(errors);
   }
   ;
   
   return errorMessage;
};

export const isAlreadyUnlockedMessage = message => (message || '').includes('already unlocked');